export const COOKIE_KEYS = {
  WINDSTREAM_CART_TOKEN: "windstream_cart_token",
  UTM_PARAMETER_PREFIX: "utm_",
  UTM_PARAMETERS: "utm_parameters",
  GUEST_USER_ID: "win_guest_user_id",
  CART_RETENTION_FLAG: "win-cart-retention-flag",
};
